/**
 * @author Amol Rathod
 */

// Import the 'axios' library to make HTTP requests to the API.
import axios from "../api/axios";

/**
 * Function to initiate the process of changing a user's password.
 *
 * @param {string} id - The user's ID or identifier.
 * @param {string} oldPassword - The user's current or old password.
 * @param {string} newPassword - The desired new password.
 * @param {string} confirmPassword - The confirmation of the new password.
 * @returns {Promise} - A promise representing the asynchronous password change request.
 * @throws {Error} - If there is an issue during the password change process.
 */
export const changePassword = async (
  id,
  oldPassword,
  newPassword,
  confirmPassword
) => {
  try {
    const token = localStorage.getItem('token');
    // Send an HTTP PUT request to the '/change_password' endpoint to change the password.
    const response = await axios.put("/change_password", {
      Id: id,
      oldPassword,
      newPassword,
      confirmPassword,
    },{
      headers:{
        Authorization :` Bearer ${token}`
      }
    });

    // Return the response data as the result of the password change process.
    return response;
  } catch (error) {
    console.log('error', error.message);

    // Check if the error is related to JSON parsing
    if (error.response && error.response.status === 400) 
    {
      // If it is a 400 Bad Request error, handle it gracefully
      return { status: 400, data: { error: "Invalid request. Please try again." } };
    }else if (error.response.status === 401 || 403)
    {
      //If unauthorized or forbidden
        return {status : 401 , data :{error: 'Unauthorizes user'}}
    }else 
    {
      // If it is another type of error, log it and handle it accordingly
      console.error("An error occurred during password change:", error);
      return { status: 500, data: { error: "An error occurred. Please try again later." } };
    }
  }
};
